import { ContractTemplate } from '../../lib/types/models/contract-template/contract-template'
import { ContractTemplateInput } from '../../lib/types/models/contract-template/contract-template-input'
import { UpdateInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function updateContractTemplate(input: UpdateInput<ContractTemplateInput>) {
  const { id, ...data } = input
  return restApiClient
    .url(constructApiUrl(API.contractTemplate.update.url, { id }))
    .patch<ContractTemplate, Partial<ContractTemplateInput>>(data)
}
